// Core imports
import * as React from 'react';

// Components imports

// Models imports

// Style and misc imports
import './ChipsInput.scss';

class ChipsInput extends React.Component<IChipsInputProps, IChipsInputState> {
  private inputRef: any = null;

  constructor(props: IChipsInputProps) {
    super(props);

    this.state = {
      chipInputValue: ''
    };
  }

  /* 
    renderChips
   */
  private renderChips = (): JSX.Element[] => {
    const chipsResult: JSX.Element[] = [];
    const { chips, chipClassName, onRemoveChip } = this.props;
    if (chips && chips.length !== 0) {
      chips.map((chip, index) => {
        chipsResult.push(
          <div key={index} className={`rp-chips-input--chip ${chipClassName}`}>
            <span className="chip-value">{chip}</span>
            <i
              className="rpds-close chip-delete-button"
              onClick={() => {
                onRemoveChip(chip);
              }}
            />
          </div>
        );
      });
    }
    return chipsResult;
  };

  /* 
    handleChipInput
   */
  private handleChipInput = (event: any) => {
    const { target } = event;
    const { max, chips } = this.props;

    if (max === undefined || chips.length < max) {
      this.setState({ chipInputValue: target.value });
    }
  };

  /* 
    handleEnterToAdd
   */
  private handleEnterToAdd = (event: any) => {
    const { chips, max, onAddChip, onAddAllChip, clearOnAdd } = this.props;
    const { chipInputValue } = this.state;
    const { key } = event;

    if (key === 'Enter' || key === ' ') {
      if ((chipInputValue !== '' && chips.length < max) || max === undefined) {
        if (onAddChip) {
          onAddChip(chipInputValue);
        }
        if (onAddAllChip) {
          onAddAllChip([...chips, chipInputValue]);
        }
        if (clearOnAdd) {
          this.setState({ chipInputValue: '' });
        }
      }
    }
  };

  public render() {
    const {
      containerClassname,
      inputClassname,
      placeholder,
      errorClassname,
      errorState
    } = this.props;
    const errorClass = errorState ? errorClassname : '';

    return (
      <div
        className={`rp-chips-input ${containerClassname} ${errorClass}`}
        onClick={() => {
          if (this.inputRef) {
            this.inputRef.focus();
          }
        }}
      >
        <div className="rp-chips-input--chips">{this.renderChips()}</div>
        {this.props.chips && this.props.chips.length < 3 && (
          <div className="rp-chips-input--input-container">
            <input
              ref={ref => (this.inputRef = ref)}
              className={`rp-chips-input--input ${inputClassname}`}
              type="text"
              placeholder={placeholder ? placeholder : ''}
              value={this.state.chipInputValue}
              onChange={this.handleChipInput}
              onKeyPress={this.handleEnterToAdd}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ChipsInput;

interface IChipsInputProps {
  onAddChip?(chips: any): void;
  onAddAllChip?(chips: any[]): void;
  onRemoveChip(chip: any): void;
  chips: any[];
  containerClassname: string;
  inputClassname: string;
  chipClassName: string;
  max?: number;
  placeholder?: string;
  errorClassname?: string;
  errorState?: boolean;
  clearOnAdd: boolean;
  useSuggestions?: boolean;
  suggestions?: any[];
  loadingSuggestions?: boolean;
  userOnlySuggestions?: boolean;
}

interface IChipsInputState {
  chipInputValue: string;
}
